import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCamera2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="camera-2, picture, image, cam"><path d="M2.75 20.25V5.75H8.53513C9.22675 4.5544 10.5194 3.75 12 3.75C13.4806 3.75 14.7733 4.5544 15.4649 5.75H21.25V20.25H2.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M15.25 12.5C15.25 14.2949 13.7949 15.75 12 15.75C10.2051 15.75 8.75 14.2949 8.75 12.5C8.75 10.7051 10.2051 9.25 12 9.25C13.7949 9.25 15.25 10.7051 15.25 12.5Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCamera2;
